export const getDataById = (context, id, what = "supplements", field) => {
  let a = context["data"][what].filter((item) => item["id"] === id)[0];
  if (field) {a = a[field] ? a[field] : null}
  return a;
};
export const getDataById2 = (context, id, field, what = "supplements") => {
  let a = context["data"][what].filter((item) => item["id"] === id)[0];
  if (field && a) {a = a[field] ? a[field] : false}
  return a;
};

export const getDataByCode = (context, code, what = "supplements", field) => {
  let a = context["data"][what].filter((item) => item["code"] === code)[0];
  if (field) {a = a[field] ? a[field] : null}
  return a;
};


export const calculateTotal = (context) => {
  if (!context.handles.getStack().length) return 0;
  let sum = 0;
  context.handles.getStack().forEach((itm) => {
    let id = itm['id']
    let pr = getDataById(context, id)["ppu"];
    sum += getDataById(context, id)["ppu"];
  });
  sum = Math.ceil(sum * 100) / 100;
  return sum;
};


export const codeHashToCopy = (hash) => {
  return hash.replace(/ /g, "-").replace(/,+/g, ",").replace(/;+/g, ";");
};